<template>
  <div class="error-contain">
    <div class="e-inner">
      <img class="sImg" src="/static/img/error.png">
      <div class="info">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error",
  data: function () {
    return {
      message: this.$route.params.message ? this.$route.params.message : "该域名没有绑定学校，请检查输入!",
    };
  },
  mounted: function () {
    console.log(this.message);
  }
}
</script>

<style lang="css" scoped>
.error-contain{
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, #57a9eb 0%, #c6e1f8 50%, #ffffff 100%);
  background-image: -webkit-linear-gradient(to bottom, #57a9eb 0%, #c6e1f8 50%, #ffffff 100%);
  background-image: -moz-linear-gradient(to bottom, #57a9eb 0%, #c6e1f8 50%, #ffffff 100%);
  background-image: -ms-linear-gradient(to bottom, #57a9eb 0%, #c6e1f8 50%, #ffffff 100%);
  background-image: -o-linear-gradient(to bottom, #57a9eb 0%, #c6e1f8 50%, #ffffff 100%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap:nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.e-inner{
  text-align: center;
  margin-top: 15%;
}
.e-inner .sImg{
  width: 200px;
  height: auto;
  margin: 0px auto;
}
  .info{
    text-align: center;
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/common/error.vue